import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IExclusivityAvailabilityState) {
    (function(State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        /**
     * brand has exclusivity enabled, but this retailer has not activated an exclusivity relationship
     */ State["AVAILABLE"] = "AVAILABLE";
        /**
     * brand has active exclusivity relationship and option to cancel with this retailer
     */ State["PENDING"] = "PENDING";
        /**
     * Brand has an active exclusivity agreement with this retailer, and both brand and retailer are committed
     */ State["ACTIVE"] = "ACTIVE";
        /**
     * retailer is unable to purchase from this brand due to exclusivity agreement of another retailer
     */ State["BLOCKED"] = "BLOCKED";
        /**
     * brand does not have exclusivity enabled, and retailer has not requested exclusivity
     */ State["NOT_ENABLED"] = "NOT_ENABLED";
        /**
     * retailer is not eligible for exclusivity with this brand (even if brand has exclusivity enabled)
     */ State["NOT_AVAILABLE"] = "NOT_AVAILABLE";
        /**
     * brand does not have exclusivity enabled, and retailer has requested exclusivity
     */ State["REQUESTED"] = "REQUESTED";
        /**
     * brand has blocked all purchases in this zipcode
     */ State["ZIPCODE_BLOCKED"] = "ZIPCODE_BLOCKED";
        /**
     * retailer has an unsettled agreement with the brand
     */ State["UNSETTLED_AGREEMENT"] = "UNSETTLED_AGREEMENT";
    })(IExclusivityAvailabilityState.State || (IExclusivityAvailabilityState.State = {}));
    IExclusivityAvailabilityState.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IExclusivityAvailabilityState || (IExclusivityAvailabilityState = {}));
export var IExclusivityAvailabilityState;
